import { Fallback } from './WhyBuyMediaFallback.styles';

export default function WhyBuyMediaFallback() {
  return <Fallback aria-hidden data-testid="why-buy-media-fallback" />;
}
